export default __webpack_public_path__ + "static/media/fake5.239fd8fe.jpg";